'use strict';

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import MerchantInfo from './merchant-info';
import StoreFrontAnalytics from './storefront-google-analytics';

import storeFrontActions from '../../redux/storefrontActions';
import activityLogActions from '../../redux/activityLogAction';
import subMarketplaceActions from '../../redux/subMarketplaceActions';
import { Layout } from '../layouts/layout/layout';
import { Container, Divider } from '@mui/material';
import StorefrontContent from './storefront-content';

class StoreFrontPageComponent extends React.Component {
    constructor(props) {
        super(props);
        this.goToPage = this.goToPage.bind(this);
    }

    componentDidMount() {}

    goToPage(pageNo, filters) {
        const sellerid = this.props.merchantUser.ID;
        window.location = '/storefront/' + sellerid + '?pageNo=' + pageNo + '&&keyword=' + filters.keyword;
    }

    render() {
        console.log('this.props', this.props);
        const filters = {
            keyword: this.props.keyword
        };

        return (
            <React.Fragment>
                <StoreFrontAnalytics
                    analyticsApiAccess={this.props.analyticsApiAccess}
                    baseUrl={process.env.BASE_URL}
                    merchantUser={this.props.merchantUser}
                    onAddPageAnaylytics={this.props.onAddPageAnaylytics}
                    onHasPageAnaylytics={this.props.onHasPageAnaylytics}
                />
                <Layout user={this.props.user} categories={this.props.categories} panels={this.props.panels}>
                    <div className='store-container' id='store-container'>
                        <Container maxWidth='lg' className='tw-py-[24px]'>
                            <MerchantInfo
                                merchantTotalVisits={this.props.merchantTotalVisits}
                                customFieldDefinitions={this.props.customFieldDefinitions}
                                merchantFeedback={this.props.merchantFeedback}
                                merchantUser={this.props.merchantUser}
                                sellerCountry={this.props.sellerCountry}
                                ReviewAndRating={this.props.ReviewAndRating}
                            />

                            <Divider className='tw-my-[24px]' />

                            <StorefrontContent {...this.props} goToPage={this.goToPage} filters={filters} />
                        </Container>
                    </div>
                </Layout>
            </React.Fragment>
        );
    }
}

StoreFrontPageComponent.propTypes = {
    user: PropTypes.shape({
        ProfileProgress: PropTypes.number
    })
};

function mapStateToProps(state, ownProps) {
    return {
        items: state.itemsReducer.items,
        keyword: state.itemsReducer.keyword,
        merchantUser: state.merchantReducer.user,
        user: state.userReducer.user,
        userPreferredLocationId: state.userReducer.userPreferredLocationId,
        sellerCountry: state.merchantReducer.sellerCountry,
        merchantFeedback: state.merchantReducer.merchantFeedback,
        ReviewAndRating: state.merchantReducer.ReviewAndRating,
        customFieldDefinitions: state.itemsReducer.customFieldDefinitions,
        merchantTotalVisits: state.itemsReducer.merchantTotalVisits,
        analyticsApiAccess: state.merchantReducer.analyticsApiAccess
    };
}

function mapDispatchToProps(dispatch) {
    return {
        updateKeyWord: e => dispatch(storeFrontActions.updateKeyWord(e.target.value)),
        searchStoreFront: (keyword, merchantID, pageNo) =>
            dispatch(storeFrontActions.searchStoreFront(keyword, merchantID, pageNo)),
        searchMerchantFeedback: options => dispatch(storeFrontActions.getMerchantFeedback(options)),
        onAddPageAnaylytics: data => dispatch(activityLogActions.addPageAnaylytics(data)),
        onHasPageAnaylytics: (options, callback) => dispatch(activityLogActions.hasPageAnaylytics(options, callback)),
        getMerchantItems: callback => dispatch(subMarketplaceActions.getMerchantItems(callback)),
        getMerchantFavorites: callback => dispatch(subMarketplaceActions.getMerchantFavorites(callback))
    };
}

const StoreFrontPage = connect(mapStateToProps, mapDispatchToProps)(StoreFrontPageComponent);

export { StoreFrontPage, StoreFrontPageComponent };

export default {
    StoreFrontPage,
    StoreFrontPageComponent
};
